import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';
import Getintouch from '../Home/Getintouch';
interface gallerydata {
  id: number,
  image: string,
  event_id?: number
}
interface EventData {
  id: number,
  heading: string,
  start_date: string
}

const Gallery = () => {
  const [galleryimagedata, setGalleryImagedata] = useState<gallerydata[]>([]);
  const [eventsList, setEventsList] = useState<EventData[]>([]);
  const [selectedEvent, setSelectedEvent] = useState<string>('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<gallerydata[]>(
          `https://rmbbackend.rmbjaipur.com/auth/gallery${selectedEvent ? `?event_id=${selectedEvent}` : ''}`
        );
        setGalleryImagedata(response.data);
      } catch (error) {
        console.error("gallery Not Found:", error);
        setGalleryImagedata([]); // clear on error
      }
    };
    fetchData();
  }, [selectedEvent]);

  useEffect(() => {
    axios.get('https://rmbbackend.rmbjaipur.com/auth/events')
      .then(res => {
        const list = Array.isArray(res.data) ? res.data : (res.data?.events || res.data?.data || []);
        setEventsList(list);
      })
      .catch(err => console.error(err));
  }, []);

  return (
    <div>
      <Header />
      <div className="bg-[#1E2A3A]   py-[50px] px-[8%]">
        <p className="text-[#F1F4F9] text-[16px] text-center">Stories FROM</p>
        <div className=" relative z-10 text-[#FDBC12] text-[39px] font-bold text-center">
          <h2 className="leading-12	">Event and Meetings</h2>
        </div>

        <div className="flex justify-center mt-6">
          <select
            className="w-full md:w-1/3 border px-3 py-2 rounded-lg text-black bg-white focus:outline-none focus:ring-2 focus:ring-[#FDBC12]"
            value={selectedEvent}
            onChange={(e) => setSelectedEvent(e.target.value)}
          >
            <option value="">All Gallery Images</option>
            {eventsList.map(evt => (
              <option key={evt.id} value={evt.id}>{evt.heading} ({evt.start_date})</option>
            ))}
          </select>
        </div>

        <div className="flex flex-wrap sm:justify-start justify-center gap-[2%] gap-y-4  mt-10">
          {galleryimagedata.map((image) => (
            <img key={image.id} className="md:w-[23%] sm:w-[48%] h-48 object-cover rounded shadow-md" src={`https://rmbbackend.rmbjaipur.com/${image.image}`} alt="gallery" />
          ))}
          {galleryimagedata.length === 0 && (
            <p className="text-white text-center w-full mt-10">No images found for this selection.</p>
          )}
        </div>
      </div>
      <Getintouch />
      <Footer />
    </div>
  )
}

export default Gallery